import { createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import Types from '../Actions/Types'

export const INITIAL_STATE = Immutable({
  formData: {}
})


const initializeForm = (state, action) => {
  const { formData } = action
  return state.merge({
      formData
  })
}


const ACTION_HANDLERS = {
  [Types.INITIALIZE_FORM]: initializeForm,  
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)
